import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './meeting.types';

export const meetingSelectors = {
  ...generateResourceSelectors<types.IMeeting>((state) => state.resource.meeting),
};
